import React from "react";
import { Button } from "@mui/material";

const SidebarFooter = ({ isCollapsed, isMobile, footerItems, handleItemClick }) => {
  return (
    <div className={`sidebar-footer ${isCollapsed && !isMobile ? "collapsed" : ""}`}>
      <div className="footer-content">
        {footerItems.map((item) => {
          const Icon = item.icon;
          return (
            <Button
              key={item.title}
              className={`footer-item ${isCollapsed && !isMobile ? "collapsed" : ""}`}
              onClick={() => handleItemClick(item)}
              title={isCollapsed && !isMobile ? item.title : ""}
              sx={{
                height: isCollapsed && !isMobile ? "44px" : "48px",
                width: isCollapsed && !isMobile ? "44px" : "100%",
                justifyContent: isCollapsed && !isMobile ? "center" : "flex-start",
                padding: isCollapsed && !isMobile ? "0" : "0 16px",
                borderRadius: "12px",
                gap: "12px",
                textTransform: "none",
                backgroundColor: "transparent",
                color: "#2c2c3a",
                "&:hover": {
                  backgroundColor: "rgba(157,106,196,0.12)",
                  color: "#2c2c3a",
                },
                transition: "all 0.2s ease",
                ...(isCollapsed &&
                  !isMobile && {
                    marginLeft: "auto",
                    marginRight: "auto",
                    minWidth: "44px",
                    maxWidth: "44px",
                  }),
              }}
            >
              <Icon className="nav-icon" style={{ width: "20px", height: "20px", flexShrink: 0 }} />
              {(!isCollapsed || isMobile) && <span className="nav-text">{item.title}</span>}
            </Button>
          );
        })}
      </div>
    </div>
  );
};

export default SidebarFooter;
